import { type ChecklistItem as ChecklistItemType } from '@lingoda/monolith-graphql';
import { Box, Typography, colorsPalette, styled } from '@lingoda/ui';
import { CheckIcon } from '@lingoda/ui/icons/lingodaIcons';

interface Props extends ChecklistItemType {
    isActive: boolean;
    value: number;
}

export const ChecklistItem = ({ title, description, isActive, isCompleted, value }: Props) => {
    return (
        <Box display="flex">
            <StatusContainer isActive={isActive} isCompleted={isCompleted}>
                {isCompleted ? (
                    <CheckIcon size={16} />
                ) : (
                    <Typography
                        variant="body3"
                        htmlColor={isActive ? 'text.secondary' : colorsPalette.blackAlpha[20]}
                    >
                        {value}
                    </Typography>
                )}
            </StatusContainer>
            <Box sx={{ flex: '1 1 auto', marginLeft: 1 }}>
                <Typography
                    variant={isActive ? 'subtitle2' : 'body2'}
                    htmlColor={
                        isActive || isCompleted ? 'text.primary' : colorsPalette.blackAlpha[20]
                    }
                >
                    {title}
                </Typography>
                {isActive && (
                    <Box sx={{ marginTop: 0.5, color: 'text.secondary' }}>
                        <Typography fontStyle="italic">{description}</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

const StatusContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isCompleted',
})<{
    isActive: boolean;
    isCompleted: boolean;
}>(({ theme, isActive, isCompleted }) => ({
    alignItems: 'center',
    background: isCompleted
        ? theme.colors.border['progress-bold']
        : isActive
          ? colorsPalette.blackSolid[8]
          : colorsPalette.blackAlpha[5],
    color: theme.colors.text.inverse,
    borderRadius: 10,
    display: 'flex',
    flexShrink: 0,
    height: 20,
    justifyContent: 'center',
    width: 20,
}));
